<template>
  <div id="quest_reward_hub" class="drops_works quest_reward_hub">
    <div id="quest_reward_how_to_win" />
    <div class="drops_works_header">
      <div class="drops_works_title">
        <template v-if="!hubData.hub_data.hub_drops_theme">
          <i v-if="appConfig.isAvglDomain" class="sp-ic-sm-drops-arrows" />
          <i v-else class="sp-ic-sm-drops-arrows-boom" />
        </template>
        <template v-else>
          <svg-icon name="arrow-hub-drop-theme" class="hub_drop_theme_arrow" :color="parseInt(hubData.hub_data.allow_hub_drops) === 1 ? hubDropsTheme : ''" />
        </template>
        <p class="drops_works_title_text">
          How to
        </p>
        <template v-if="!hubData.hub_data.hub_drops_theme">
          <div v-if="userData.theme === 'dark'">
            <i v-if="appConfig.isAvglDomain" class="sp-ic-sm-drops-win" />
            <i v-else class="sp-ic-sm-drops-win-boom" />
          </div>
          <div v-else>
            <i v-if="appConfig.isAvglDomain" class="sp-ic-sm-drops-win-boom-light-theme" />
            <i v-else class="sp-ic-sm-drops-win-boom-light-theme" />
          </div>
        </template>
        <template v-else>
          <svg-icon name="win-text" class="hub_drop_theme_win_text" :color="parseInt(hubData.hub_data.allow_hub_drops) === 1 ? hubDropsTheme : ''" />
        </template>
      </div>
      <template v-if="hubData.hub_data.text_how_to_win">
        <p class="drops_works_desc hub_drops_desc" v-html="hubData.hub_data.text_how_to_win" />
      </template>
      <template v-else-if="hubData.hub_data.alias === 'la-liga'">
        <p v-if="isMobile()" class="drops_works_desc hub_drops_desc">
          Complete challenges throughout the coming weeks to qualify for the <span style="font-weight: 800; font-size: 14.58px">LaLiga FIFA {{ currentCity }} Showcase.</span>
        </p>
        <p v-else class="drops_works_desc hub_drops_desc">
          Complete challenges throughout the coming weeks to qualify for <br>
          the <span style="font-weight: 800; font-size: 18px">LaLiga FIFA {{ currentCity }} Showcase.</span>
        </p>
      </template>
    </div>
    <!--	SLIDER START	-->
    <div v-if="isMobile()" class="completed_challenges_title">
      Open Challenges
    </div>
    <div v-if="quests && Object.keys(quests).length > 0" class="landing_slider hub_drop_open_quest">
      <img
        v-if="isLoading"
        id="leaderboard_loading_img"
        class="lazyload"
        :data-src="contentCloudFrontWithVersion('/ellipsis.svg')"
        style="width: 100%; height: 100px; position: relative;"
      >
      <div
        ref="hub_quests_slick"
        class="variable-width"
        data-slick="{&quot;infinite&quot;: false, &quot;speed&quot;: 300, &quot;slidesToShow&quot;: 3, &quot;centerMode&quot;: false, &quot;variableWidth&quot;: true, &quot;initialSlide&quot;: 0, &quot;draggable&quot;: true, &quot;responsive&quot;: [ {&quot;breakpoint&quot;: 1605, &quot;settings&quot;: {&quot;slidesToShow&quot;: 2, &quot;slidesToScroll&quot;: 1}}, {&quot;breakpoint&quot;: 576, &quot;settings&quot;: {&quot;slidesToShow&quot;: 1, &quot;slidesToScroll&quot;: 1}}]}"
      >
        <quest-card-hub
          v-for="(quest, index) in quests"
          :key="index"
          :quest="quest"
          :submit-quest="submitQuest"
          :drop-id="dropId"
        />
      </div>
    </div>
    <!--	SLIDER END	-->
    <completed-challenges v-if="appConfig.auth_check && Object.keys(completedQuests).length > 0" :completed-quests="completedQuests" />
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import QuestCardHub from './QuestCardHub';
import CompletedChallenges from './CompletedChallenges';
import SvgIcon from '../../../components/shared/icons/index';
import 'slick-carousel/slick/slick.min';
import Vue from 'vue';
import jQuery from 'jquery';
import { ModalMixin } from '../../../mixins/modal';
import { HubMixin } from '../../../mixins/hub';
import { fbPixelEvent } from '../../../mixins/fbpixel-event';

export default {
  components: { QuestCardHub, CompletedChallenges, SvgIcon },
  mixins: [component, ModalMixin, HubMixin, fbPixelEvent],
  props: {
    questData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dropId: 0,
      currentCity: 'San Jose',
      currentDrop: {},
      quests: {},
      isLoading: true,
      completedQuests: {},
    };
  },
  watch: {
    questData: {
      handler(newVal, oldVal){
        this.handleUpdateCompletedQuest();
      },
      deep: true,
    },
  },
  created() {
    this.getQuest();
  },
  methods: {
    initSlick() {
      jQuery(this.$refs.hub_quests_slick).slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        centerMode: false,
        variableWidth: true,
        initialSlide: 0,
        draggable: true,
        responsive: [
          {
            breakpoint: 1605,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
      jQuery(this.$refs.hub_quests_slick).find('.slick-prev').first().css('background-color', this.hubDropsTheme);
      jQuery(this.$refs.hub_quests_slick).find('.slick-next').first().css('background-color', this.hubDropsTheme);
      var slideCount = 0;
      jQuery(this.$refs.hub_quests_slick)
        .find('.slick-prev')
        .first()
        .addClass('btn_slick_disable');
      jQuery(this.$refs.hub_quests_slick).on('beforeChange', function(
        event,
        slick,
        current_slide,
        nextSlide
      ) {
        if (nextSlide === 0) {
          jQuery(this).find('.slick-prev').first().addClass('btn_slick_disable');
        } else {
          jQuery(this).find('.slick-prev').first().removeClass('btn_slick_disable');
        }
      });
      jQuery(this.$refs.hub_quests_slick).on('afterChange', function(
        event,
        slick,
        current_slide
      ) {
        var slide_show = slick.slickGetOption('slidesToShow');
        slideCount = jQuery(this).find('.drops_works_card').length;
        if (current_slide > slideCount - slide_show - 1) {
          jQuery(this).find('.slick-next').first().addClass('btn_slick_disable');
        } else {
          jQuery(this).find('.slick-next').first().removeClass('btn_slick_disable');
        }
      });
    },
    destroySlick() {
      jQuery(this.$refs.hub_quests_slick).slick('unslick');
    },
    async submitQuest(data, callback) {
      const url = this.routeSubmitHubDropQuest();
      const configHeader = {
        headers: {
          'X-CSRF-TOKEN': this.appConfig.csrfToken,
        },
      };
      console.log(data.submitted_screenshot);
      if (data.submitted_screenshot && data.submitted_screenshot.size > 15 * 1024 * 1024) {
        this.showModalBoomMsg('The size of screenshot image may not be greater than 15MB');
        return;
      }
      const formData = new FormData();
      formData.append('hub_id', this.hubData.hub_data.id);
      formData.append('drop_id', data.drop_id);
      formData.append('goal', data.goal);
      formData.append('quest', data.quest);
      formData.append('submitted_screenshot', data.submitted_screenshot);
      formData.append('submitted_value', data.submitted_value);

      await this.$http.post(url, formData, configHeader)
        .then(response => {
          // send facebook pixel tracking after user submit quest
          if (response.data.status === 0) {
            if (this.hubData.hub_data.alias === 'la-liga' && this.questData.current_drop) {
              var questSubmit = JSON.parse(data.quest);
              var challengeName = questSubmit.goals[0].description;
              this.customTracking('Challenges', {
                challengename: '[' + challengeName + ']',
                venuename: this.questData.current_drop.current_city,
              });
            }
            callback();
          } else {
            this.showModalBoomMsg(response.data.msg);
          }
          // this.getQuest();
        }).catch(error => {
          this.showModalBoomMsg('Somethings went wrong. Please try again!');
          console.log('submitQuest error');
          console.log(error);
        });
    },
    getQuest() {
      this.destroySlick();
      this.currentDrop = this.questData.current_drop;
      this.dropId = (this.questData.current_drop && this.questData.current_drop.id) ? this.questData.current_drop.id : 0;
      this.currentCity = (this.questData.current_drop && this.questData.current_drop.current_city) ? this.questData.current_drop.current_city : 'San Jose';
      this.quests = this.questData.quests;
      this.completedQuests = this.questData.completed_quests;
      this.isLoading = false;
      Vue.nextTick(() => {
        this.initSlick();
      });
    },
    handleUpdateCompletedQuest() {
      this.getQuest();
    },
  },
};
</script>
